import { useBreakpointValue } from '@genial/utils';

import { ProductInfoDesktop } from './desktop';
import { ProductInfoMobile } from './mobile';

export const ProductInfo = (props) => {
  const responsiveProductInfo = useBreakpointValue({
    base: <ProductInfoMobile {...props} />,
    sm: <ProductInfoDesktop {...props} />,
  });

  return responsiveProductInfo;
};
